import {merge} from "lodash";
import de from "./de.json";
import fr from "./fr.json";
import it from "./it.json";

const messages = merge({}, { de, fr, it }, (window?.bomlang || {}));

export default messages;
